export const PricePerUnit = ({ unit = '', unitPrice = 0 }) => {
  if (!unit || unitPrice == null) return null;

  const priceNum = Number(unitPrice);

  const twoDecimal = Number(priceNum.toFixed(2));
  const threeDecimal = Number(priceNum.toFixed(3));

  // If both 2-decimal and 3-decimal values are 0 → render nothing
  if (twoDecimal === 0 && threeDecimal === 0) return null;

  // Decide what to display
  const displayPrice = twoDecimal !== 0 ? twoDecimal.toFixed(2) : threeDecimal.toFixed(3);

  return (
      <div className="mt-3 rounded-[10px] px-3 py-2 text-center bg-teal-400/30">
          <p className="text-xs font-medium text-gray-500">Per {unit}</p>
          <p className="text-sm font-semibold text-black">
              ${displayPrice}
          </p>
      </div>
  );
};
